export class Search {
  constructor(id, code, desc, uom, fullDescription) {
    this.id = id;
    this.code = code;
    this.desc = desc;
    this.label = code + " - " + fullDescription;
    this.value = code + " - " + fullDescription;
    this.uom = uom;
    this.fullDescription = fullDescription;
    // this.uom = Date.now() % 2 ? "KG": uom;
  }
  static fromApiObject(input) {
    if (input && typeof(input) === "object") {
      return new Search(input.id, input.hs_code, input.description, input.uom, input.full_description || input.description)
    }
    return new Search();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Search.fromApiObject(item));
    }
    if (typeof(input) === "object") {
      return [Search.fromApiObject(input)];
    }
    return [];
  }
}